import { USE_ELEVENLABS, APP_NAME } from '../config.js';

export const getSpeechUrl = (speechUrl) => {
  if (USE_ELEVENLABS && speechUrl) {
    return `${speechUrl}?provider=elevenlabs`;
  }
  if (APP_NAME === 'corsica') {
    return null;
  }
  return speechUrl;
};
